import React from "react";
import { PageHeader } from "@/components/common/PageHeader";
import { Skeletons } from "@/components/common/EmptyState";
import { useResource } from "@/hooks/useResource";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { ChatCircleDots } from "@phosphor-icons/react";

export default function Team() {
  const { items: activity } = useResource("activity");
  const { data: team = [], isLoading } = useQuery({ queryKey: ["team"], queryFn: async () => (await api.get("/team")).data });

  return (
    <div>
      <PageHeader title="Team Collaboration" subtitle="Presence, activity and shared work" icon={ChatCircleDots} />
      {isLoading ? <Skeletons /> : (
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <h2 className="mb-3 text-sm font-bold uppercase tracking-wider text-muted-foreground">The Team</h2>
            <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
              {team.map((u) => (
                <div key={u.id} data-testid="team-member" className="flex items-center gap-3 rounded-2xl border border-border bg-surface-raised p-4">
                  <div className="relative">
                    <Avatar className="h-11 w-11"><AvatarImage src={u.avatar} /><AvatarFallback>{u.name?.[0]}</AvatarFallback></Avatar>
                    <span className="absolute bottom-0 right-0 h-3 w-3 rounded-full border-2 border-surface-raised bg-lime-400" />
                  </div>
                  <div><p className="font-semibold">{u.name}</p><p className="text-xs capitalize text-muted-foreground">{u.role?.replace(/_/g, " ")}</p></div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h2 className="mb-3 text-sm font-bold uppercase tracking-wider text-muted-foreground">Activity Feed</h2>
            <div className="space-y-4 rounded-2xl border border-border bg-surface-raised p-5">
              {activity.map((a) => (
                <div key={a.id} className="flex items-start gap-3">
                  <Avatar className="h-8 w-8 shrink-0"><AvatarImage src={a.avatar} /><AvatarFallback>{a.user?.[0]}</AvatarFallback></Avatar>
                  <p className="text-sm leading-snug"><span className="font-semibold">{a.user}</span> <span className="text-muted-foreground">{a.action}</span></p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
